import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
      this.matIconRegistry.addSvgIcon(
        'instagram',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/instagram.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'facebook',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/facebook.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'twitter',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/twitter.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'youtube',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/youtube.svg')
      );
    }

    ngOnInit(): void {
    }

    getCguUrl() {
      const pdfPath = 'assets/docs/petites_annonces_SECF_CGU_v_Def.pdf';
      return this.domSanitizer.bypassSecurityTrustUrl(pdfPath);
    }
}
